export default {
  init() {
    // JavaScript to be fired on the home page

    var dpdFavourites = JSON.parse(window.localStorage.getItem('favourites'));

    console.log('favs', dpdFavourites);

    if (dpdFavourites === null) {
      dpdFavourites = [];
    } else {
      $.each(dpdFavourites, function(index, item) {
        $('.dpd-card_fav.id-'+item).addClass('active');
      });
    }
    
    $('.dpd-card_fav').on('click', function(e){
      e.preventDefault();

      const id = $(this).data('id');

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');

        const index = dpdFavourites.indexOf(id.toString());
        if (index > -1) {
          dpdFavourites.splice(index, 1);
        }
      } else {
        $(this).addClass('active');

        dpdFavourites.push(id.toString());
      }

      window.localStorage.setItem('favourites', JSON.stringify(dpdFavourites));

      e.stopPropagation();
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js